// extracted by mini-css-extract-plugin
module.exports = {"post":"posts-module--post--3Rt6V"};